import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Modal, modalClasses, ModalContent, Typography } from "@kaltura/ds-react-components";

export const StyledModal = styled(Modal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        [theme.breakpoints.up("xs")]: {
            width: 558,
        },
    },
}));

export const Separator = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

export const StyledModalContent = styled(ModalContent)({
    textAlign: "center",
});

export const StyledIconRow = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "center",
    marginBottom: theme.spacing(3),
}));

export const StyledTypography = styled(Typography)({
    width: 36,
    height: 36,
    "& > svg": {
        width: "100%",
        height: "100%",
    },
});
